import React from 'react';
import { Box, Button, FormControlLabel, Checkbox } from '@material-ui/core';

const FilterBar = ({
  showOnlyChanged,
  setShowOnlyChanged,
  changedRowsCount,
  canNavigatePrevious,
  canNavigateNext,
  handlePreviousMissing,
  handleNextMissing,
  isLoading,
  isSaving,
  isFiltersFixed,
  gridRightEdge
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 3,
        flexWrap: 'wrap',
        alignItems: 'center',
        ...(isFiltersFixed && {
          position: 'fixed',
          top: 44,
          left: gridRightEdge,
          zIndex: 1300, // Higher than React Admin AppBar (1100)
          backgroundColor: 'white',
          padding: 2,
          borderRadius: 1,
          boxShadow: 2,
          justifyContent: 'flex-end' // Align buttons to the right
        })
      }}
    >
      <Button
        variant="outlined"
        onClick={handlePreviousMissing}
        disabled={!canNavigatePrevious || isLoading || isSaving}
        size="small"
      >
        הקודם לטיוב
      </Button>
      <Button
        variant="outlined"
        onClick={handleNextMissing}
        disabled={!canNavigateNext || isLoading || isSaving}
        size="small"
      >
        הבא לטיוב
      </Button>
      <FormControlLabel
        control={
          <Checkbox
            checked={showOnlyChanged}
            onChange={(e) => setShowOnlyChanged(e.target.checked)}
            disabled={isSaving}
            color="primary"
          />
        }
        label={`הצג רק שורות שעודכנו (${changedRowsCount})`}
      />
    </Box>
  );
};

export default FilterBar;
